import React, { useState } from 'react'

import AudioPreview from '@components/shared/AudioPreview'
import NFIcon from '@components/shared/NFIcon'
import Product from '@models/Product'
import Score from '@models/Score'
import { getScoreIcon } from '@models/util/score.util'
import { useAudioPreview } from '@providers/AudioPreviewProvider'

interface Props {
  score: Score | Product
}
const AudioPreviewHandle: React.FC<Props> = ({ score }) => {
  const { isPlaying } = useAudioPreview()
  const [hover, setHover] = useState(false)
  return (
    <div
      className="w-[25px] flex flex-row items-center mr-3.5 group text-h3"
      onMouseOver={() => setHover(true)}
      onMouseOut={() => setHover(false)}>
      {hover || isPlaying(score.id) ? (
        <AudioPreview
          id={score.id}
          url={score.audio_preview_url}
          className="text-orange hover:text-orange-dark disabled:text-gray-dim"
        />
      ) : (
        <NFIcon icon={getScoreIcon(score)} className="text-gray-icons dark:text-gray-icons-dm" />
      )}
    </div>
  )
}

export default AudioPreviewHandle
